export default {
  statusData: [],
  loading: false,
}

